var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf08W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vectorsolutons-1",
    d: "M.115,2.932c.441-.068.867-.13,1.291-.2A27.427,27.427,0,0,0,8.4.772C8.87.558,9.318.3,9.769.052A.278.278,0,0,1,10.08.044a24.835,24.835,0,0,0,7.248,2.622c.76.148,1.533.233,2.3.348.067.01.133.022.246.04,0,.222,0,.449,0,.675.044,2.775.107,5.55.125,8.326a20.07,20.07,0,0,1-.177,2.733A6.966,6.966,0,0,1,18.549,17.8a13.939,13.939,0,0,1-3.5,3.4,29.855,29.855,0,0,1-4.978,2.771.332.332,0,0,1-.242.007,25.027,25.027,0,0,1-6.272-3.813A11.755,11.755,0,0,1,.573,16.375,6.4,6.4,0,0,1,0,13.52C.011,10.96.036,8.4.061,5.84.07,4.952.1,4.064.114,3.176c0-.077,0-.155,0-.243Z",
    transform: "translate(15 12.676)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf08W);
export default __webpack_public_path__ + "static/media/icon-wf-08-w.4990991b50358442d064b66a54019ab9.svg";
export { ForwardRef as ReactComponent };